import React from "react";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import ButtonMAS from "ButtonMAS/ButtonMAS";
import s from "./Header.module.scss";
import HeaderMenu from "./header-menu/HeaderMenu";

const Header = ({ sidebarHandling }) => {
  const { isCollapse, handleSidebarCollapse } = sidebarHandling;

  return (
    <div className={s.headerContainer}>
      <div>
        {isCollapse && (
          <ButtonMAS
            variant="text-only"
            className={s.collapseBtn}
            onClick={handleSidebarCollapse}
          >
            <MenuIcon sx={{ color: "#309EA7" }} />
          </ButtonMAS>
        )}
        {!isCollapse && (
          <ButtonMAS
            variant="text-only"
            className={s.collapseBtn}
            onClick={handleSidebarCollapse}
          >
            <MenuOpenIcon sx={{ color: "#309EA7" }} />
          </ButtonMAS>
        )}
      </div>
      <div className={s.headerMenu}>
        <HeaderMenu />
      </div>
    </div>
  );
};

export default React.memo(Header);
